import { __decorate, __metadata } from "tslib";
import { IsUndefinable } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNumber } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
export class PatchChargeTotalAmountsDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchChargeTotalAmountsDto.prototype, "total", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchChargeTotalAmountsDto.prototype, "tax", void 0);
//# sourceMappingURL=PatchChargeTotalAmountsDto.js.map